try {
    let ogHeight = 0.7 * window.innerHeight, ogWidth = 0.7 * window.innerHeight
    let maxScroll = 0, prevScroll = window.scrollY
    let finalOffset = 0.04 * window.innerHeight
    let diffX = 0.21 * window.innerHeight, diffY = 0.86 * window.innerHeight

    window.onscroll = function() {
        let titleIcon = document.getElementById("titleIcon")
        let title = document.getElementById("title")
        let tabList = document.getElementById("tabList")
        let navbar = document.getElementById("navbar")
        // let titleBg = document.getElementById("titleBg")
        

        // console.log(tabList)
        // console.log(titleBg)
        let y = window.scrollY, vHeight = window.innerHeight
        let scrollPercentage = y / vHeight
        if(y < window.innerHeight) { // && y > maxScroll
            
            titleIcon.style.display = "";
            title.style.display = "";
            tabList.style.display = "";
            // navbar.style.display = "none"
            // console.log(scrollPercentage)
            let decreaseFactor = Math.max(0.135, 1 - scrollPercentage)
            // console.log(decreaseFactor)       
            titleIcon.style.height = "" + decreaseFactor * ogHeight + "px"
            titleIcon.style.width = "" + decreaseFactor * ogWidth + "px"
            maxScroll = y

            navbar.style.top = "-16vh"

            titleIcon.style.top = "" + 1.04 * window.innerHeight - diffY * (1 - scrollPercentage) + "px"
            titleIcon.style.left = "" + 0.25 * window.innerHeight - diffX * scrollPercentage + "px"
            title.style.fontSize = "" + 6.5 - 5 * scrollPercentage + "rem"
            tabList.style.fontSize = "" + 1.5 - 0.35 * scrollPercentage + "rem"
            title.style.top = "" + (-0.35 * window.innerHeight + 0.72 * window.innerHeight * scrollPercentage) + "px"
            title.style.left = "" + (0.95 * window.innerHeight - 0.8 * window.innerHeight * scrollPercentage) + "px"
            tabList.style.top = "" +  (-0.35 * window.innerHeight + 0.635 * window.innerHeight * scrollPercentage) + "px"
            tabList.style.left = "" + (1.05 * window.innerHeight + 0.45 * window.innerHeight * scrollPercentage) + "px"
            // title.style.top = "" + (1.04 * window.innerHeight - diffY * (1 - scrollPercentage)) + (-0.28 * window.innerHeight) + (0.28 * window.innerHeight * scrollPercentage) + "px"
            //  title.style.left = "" + 0.94 * window.innerHeight * (scrollPercentage) + "px"
        }
        else {
            titleIcon.style.display = "none";
            title.style.display = "none";
            tabList.style.display = "none";
            
            navbar.style.display = "block";
            navbar.style.top = "0px";

    

            // let titleIcon2 = document.getElementById("titleIcon2")
            // let title2 = document.getElementById("title2")
            // let tabList2 = document.getElementById("tabList2")
            
            // titleIcon2.style.display = "block";
            // title2.style.display = "block";
            // tabList2.style.display = "block";
            // titleIcon.style.position = "fixed";
            // // title.style.position = "absolute";
            // // tabList.style.position = "absolute";
            // titleIcon.style.transitionDuration = "0.5s";
            // titleIcon.style.top = "" + 0.04 * window.innerHeight + "px"
            // // console.log(y)
        }
    }
}
catch {
    
}